import adminSaga from 'admin/admin.saga';
import { all } from 'redux-saga/effects';

import mapSaga from 'map/map.saga';

import bepiSaga from 'bepi/bepi.saga';
import connectivitySaga from 'connectivity/connectivity.saga';
import covidDataSuiteSaga from 'covidDataSuite/covidDataSuite.saga';
import diseaseActivitiesGlobalSaga from 'diseaseActivitiesGlobal/diseaseActivitiesGlobal.saga';
import diseaseActivitiesInCountryLocationsSaga from 'diseaseActivitiesInCountryLocations/diseaseActivitiesInCountryLocations.saga';
import diseaseActivityUpdatesSaga from 'diseaseActivitiesInCountryLocations/diseaseActivityUpdates.saga';
import diseaseActivitiesInLocationSaga from 'diseaseActivitiesInLocation/diseaseActivitiesInLocation.saga';
import diseaseActivitiesRelevantSaga from 'diseaseActivitiesRelevant/diseaseActivitiesRelevant.saga';
import riskOverviewSaga from 'riskOverview/riskOverview.saga';
import diseaseActivitiesTemporalSaga from 'diseaseActivitiesTemporal/diseaseActivitiesTemporal.saga';
import diseaseActivitiesTimeFrameSaga from 'diseaseActivitiesTimeFrame/diseaseActivitiesTimeFrame.saga';
import diseaseActivityPanelsSaga from 'diseaseActivityPanels/diseaseActivityPanels.saga';
import diseasesSaga from 'diseases/diseases.saga';
import locationsSaga from 'locations/locations.saga';
import metadataSaga from 'metadata/metadata.saga';
import userSaga from 'user/user.saga';

import notificationSaga from './notification.saga';

// notice how we now only export the rootSaga
// single entry point to start all Sagas at once
export default function* rootSaga() {
  yield all([
    adminSaga(),
    notificationSaga(),
    covidDataSuiteSaga(),
    connectivitySaga(),
    diseaseActivityPanelsSaga(),
    locationsSaga(),
    mapSaga(),
    diseaseActivitiesInLocationSaga(),
    diseaseActivitiesGlobalSaga(),
    diseaseActivitiesTemporalSaga(),
    diseaseActivitiesTimeFrameSaga(),
    diseasesSaga(),
    riskOverviewSaga(),
    diseaseActivitiesRelevantSaga(),
    diseaseActivitiesInCountryLocationsSaga(),
    diseaseActivityUpdatesSaga(),
    metadataSaga(),
    bepiSaga(),
    userSaga(),
  ]);
}
